module.exports = __webpack_public_path__ + "static/media/sedex.3e793d83.png";